import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectIsFrenchSite } from '../../store/navigation/navigation.selectors'
import { loadPoiAssetsConfiguration } from '../../store/poiassets/poiassets.actions'
import { selectCategoriesMenu } from '../../store/poiassets/poiassets.selectors'
import { UI_ELEMENTS } from '../../store/ui/ui.constants'
import { isPE } from '../Device'
import { withEmptyFallbackErrorBoundary } from '../error/EmptyFallbackErrorBoundary'
import useUIDisplay from '../ui/useUIDisplay'
import { useAction } from '../utils/react-redux'
import s from './MenuCategoriesPE.less'
import MenuCategoryItem from './MenuCategoryItem'
import MenuSubCategoriesPE from './MenuSubCategoriesPE'

const MenuCategoriesPE = () => {
  const [categoryId, setCategoryId] = useState()
  const execLoadPoiAssetsConfiguration = useAction(loadPoiAssetsConfiguration)
  useEffect(() => {
    execLoadPoiAssetsConfiguration()
  }, [execLoadPoiAssetsConfiguration])
  const categories = useSelector(selectCategoriesMenu)
  const { showUI, hideUI } = useUIDisplay(UI_ELEMENTS.MENU_PE)

  const onTap = id => e => {
    const shouldHide = categoryId === id
    setCategoryId(shouldHide ? null : id)
    shouldHide ? hideUI() : showUI()
  }

  if (!categories || !categories.length) return <></>

  return (
    <div className={s.container}>
      <ul className={s.categories}>
        {categories.map(({ id, shortLabel, iconId, color }) => (
          <MenuCategoryItem
            key={`category-${id}`}
            id={id}
            shortLabel={shortLabel}
            color={color}
            iconId={iconId}
            selected={categoryId === id}
            active={!categoryId}
            onCategoryClick={onTap(id)}
          />
        ))}
      </ul>
      {categoryId && <MenuSubCategoriesPE categoryId={categoryId} onMouseLeaveMenu={onTap(categoryId)} />}
    </div>
  )
}

export const isMenuCategoriesPEAvailable = getState => isPE() && selectIsFrenchSite(getState())

export default withEmptyFallbackErrorBoundary(MenuCategoriesPE)
